<template>
  <e-chart
    :path-option="defaultOption"
    height="400px"
    :width="width"
    class="pa-2"
  />
</template>

<script>
import EChart from '@/components/chart/echart'

export default {
  components: {
    EChart,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
    twoBars: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      width: '99%',
    }
  },
  computed: {
    defaultOption() {
      let defaultOption = [
        ['dataset.source', this.data],
        ['color', ['#4572a7', '#93a9cf']],
        ['legend.show', true],
        ['xAxis.axisLabel.show', true],
        ['yAxis.axisLabel.show', true],
        ['grid.left', '2%'],
        ['grid.bottom', '5%'],
        ['grid.right', '3%'],
        ['series[0].type', 'bar'],
        ['series[0].areaStyle', {}],
        ['series[0].smooth', true],
      ]

      if (this.twoBars) {
        defaultOption.push(['series[1].smooth', true])
        defaultOption.push(['series[1].type', 'bar'])
        defaultOption.push(['series[1].areaStyle', {}])
      } else defaultOption.push(['series[0].barWidth', '50%'])

      return defaultOption
    },
  },
  mounted() {
    this.width = '100%'
  },
}
</script>

<style></style>
